var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHaiti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_518)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 19.9999C40 31.0456 31.0456 39.9999 20 39.9999C8.95437 39.9999 0 31.0456 0 19.9999C0 8.95431 20 -6.10352e-05 20 -6.10352e-05C20 -6.10352e-05 40 8.95431 40 19.9999Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 19.9999C0 8.95431 8.95437 -6.10352e-05 20 -6.10352e-05C31.0456 -6.10352e-05 40 8.95431 40 19.9999",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9563 25.2174L19.9998 24.3478L13.0433 25.2174V14.7825H26.9563V25.2174Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 24.3477C21.9209 24.3477 23.4782 22.7904 23.4782 20.8694C23.4782 18.9484 21.9209 17.3911 19.9999 17.3911C18.0789 17.3911 16.5216 18.9484 16.5216 20.8694C16.5216 22.7904 18.0789 24.3477 19.9999 24.3477Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 22.6086C20.9604 22.6086 21.739 21.83 21.739 20.8695C21.739 19.9089 20.9604 19.1303 19.9999 19.1303C19.0394 19.1303 18.2607 19.9089 18.2607 20.8695C18.2607 21.83 19.0394 22.6086 19.9999 22.6086Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3912 16.5216H22.6086L19.9999 19.1304L17.3912 16.5216Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1304 18.2607H20.8695V23.4782H19.1304V18.2607Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7824 22.9564H17.2171L13.0433 25.2173H26.9563L22.7824 22.9564Z",
    fill: "#6DA544"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_518"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHaiti);
export default __webpack_public_path__ + "static/media/haiti.4c8f7ad086e202f4e9c9e068803fd762.svg";
export { ForwardRef as ReactComponent };